module.exports = __webpack_public_path__ + "static/media/lateralbuys.6c0991a3.svg";